import axios from "./axiosInstance";

export const fetchReferrals = async (page = 1, perPage = 20, filter = "") => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `referrals?page=${page}&perPage=${perPage}&filterValue=${filter ?? ""}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const fetchReferralById = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`referrals/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const fetchReferralStatistics = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`referrals/statistics`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const createReferral = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`referrals`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const updateReferral = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`referrals/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const deleteReferral = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`referrals/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const fetchReferralRewards = async (page = 1, perPage = 20, filter = "") => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `referral-rewards?page=${page}&perPage=${perPage}&filterValue=${filter ?? ""}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const fetchReferralRewardById = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`referral-rewards/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

// data: { balance } — the amount to withdraw, at most the referral balance.
export const checkoutReferralBalance = async (data = {}) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`referral-rewards/transfer`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};
